import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import { getDataList } from '../../../../helpers/getDataList';
import showMessage from '../../../../helpers/showMessage';
import ProgramDetailForm from '../ProgramDetailForm';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { ROUTES_LIST } from '../../../../helpers/routesList';
import { deleteData } from '../../../../helpers/deleteData';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import './programDetailCreate.css';
import PageHeader from '../../includes/PageHeader';
import { sendFormData } from '../../../../helpers/sendFormData';
import { format, parseISO } from 'date-fns';
import { useLocation } from 'react-router-dom';

export function ProgramDetailCreate() {
    const { epgProgramId } = useParams();
    const location = useLocation();
    let selectedDate = location?.selectedDate;

    selectedDate = selectedDate
        ? parseISO(selectedDate.replace(/\//g, '-'))
        : new Date();

    const dataObj = {
        broadcastDate: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
        broadcastTime: format(new Date(), 'HH:mm'),
        duration: '',
        name: '',
        isRepeat: false,
        programTypeId: '',
        description: '',
        channelId: '',
        file: '',
        imgUrl: '',
        image: '',
    };

    const [initialData, setInitialData] = useState([dataObj]);

    // const [programAndChannel, setProgramAndChannel] = useState({ channel: {}, programTypes: [] });
    const [programAndChannel, setProgramAndChannel] = useState({
        epgProgram: {},
        programTypes: [],
    });
    const history = useHistory();
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const errorObj = {
        broadcastDate: '',
        name: '',
        programTypeId: '',
        description: '',
    };
    const [errors, setErrors] = useState([errorObj]);

    useEffect(() => {
        let isActive = true;
        const getData = async () => {
            try {
                const programTypeResponse = await getDataList('program-type');
                const programTypes = programTypeResponse.data?.data;

                const epgProgramResponse = await getDataList(
                    `program-list/${epgProgramId}`,
                );
                // const channel = epgProgramResponse.data?.data?.channel;
                const epgProgram = epgProgramResponse.data?.data;
                setProgramAndChannel({ programTypes, epgProgram });
            } catch (error) {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            }
        };
        getData();

        return () => (isActive = false);
    }, []);

    const handleDelete = () => {
        deleteData('submitUrl')
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.programList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const deleteForm = (index) => {
        if (index !== 0 && initialData[index]) {
            const filteredData = initialData.filter((_, i) => i !== index);
            setInitialData(filteredData);
        }
    };

    const addForm = () => {
        setErrors(errors.concat(errorObj));
        setInitialData(initialData.concat(dataObj));
    };

    const validate = () => {
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        const allErrors = initialData.map((data) => {
            const tempErrors = {};

            if ('broadcastTime' in data) {
                tempErrors.broadcastTime = data.broadcastTime
                    ? ''
                    : requiredMessage;
            }
            if ('duration' in data) {
                tempErrors.duration = data.duration
                    ? ''
                    : requiredMessage;
            }
            if ('broadcastDate' in data) {
                tempErrors.broadcastDate = data.broadcastDate
                    ? ''
                    : requiredMessage;
            }
            if ('name' in data) {
                tempErrors.name = data.name ? '' : requiredMessage;
            }
            return tempErrors;
        });

        setErrors(allErrors);
        return allErrors;
    };
    const handleSubmit = (e) => {
        const submitUrl =
            'program-detail-list/insert-multiple/' + `${epgProgramId}`;

        const validationErrors = validate();

        for (let i = 0; i < validationErrors.length; i++) {
            const error = validationErrors[i];
            for (const key in error) {
                if (error[key]) {
                    showMessage(
                        ERROR_MESSAGES.FILL_THE_FORM,
                        enqueueSnackbar,
                        'error',
                    );
                    return;
                }
            }
        }

        e.preventDefault();

        const requestBody = [...initialData];

        const editedNewRequestBody = requestBody.map((data) => {
            delete data.imgUrl;
            return data;
        });

        Promise.all(
            editedNewRequestBody.map((body) => sendFormData(body, submitUrl)),
        )
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.epgPage);
            })
            .catch((error) => {
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };
    return (
        <>
            <PageHeader
                pageName={
                    programAndChannel.epgProgram?.channel?.name +
                    '-н дэлгэрэнгүй хөтөлбөр оруулах'
                }
                showAddNew={false}
            />
            <Grid className="addButton">
                <Button
                    aria-label="Нэмэх"
                    color="success"
                    variant="outlined"
                    onClick={addForm}
                >
                    <AddIcon />
                    <Typography> Нэмэх </Typography>
                </Button>
            </Grid>
            {initialData.map((data, index) => (
                <Grid item style={{ marginTop: '20px' }}>
                    <ProgramDetailForm
                        key={'detail-' + index}
                        isEdit={false}
                        initialData={initialData}
                        setInitialData={setInitialData}
                        currentIndex={index}
                        allProgramType={programAndChannel.programTypes}
                        channel={programAndChannel.channel}
                        errors={errors}
                    />
                    <Grid item className="removeButton" key={'grid-' + index}>
                        <Tooltip title="Устгах">
                            <IconButton
                                style={{
                                    color: 'red',
                                    marginLeft: '30px',
                                    marginTop: '60px',
                                }}
                                onClick={() => deleteForm(index)}
                                key={'remove-' + index}
                            >
                                <RemoveCircleOutlineIcon
                                    fontSize="large"
                                    key={'add-icon-' + index}
                                />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            ))}
            <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                style={{ marginTop: '20px' }}
            >
                <Grid item>
                    <Button
                        variant="outlined"
                        type="button"
                        onClick={() => history.goBack()}
                    >
                        <ArrowBackIcon />
                        <Typography style={{ marginLeft: '10px' }}>
                            Буцах
                        </Typography>
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        color="success"
                        style={{ marginLeft: '10px' }}
                        type="submit"
                        variant="outlined"
                        onClick={(e) => handleSubmit(e)}
                    >
                        <SaveAltIcon />
                        <Typography style={{ marginLeft: '10px' }}>
                            Хадгалах
                        </Typography>
                    </Button>
                </Grid>
            </Grid>

            <Dialog
                open={showDeleteValidation}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Та энэ мэдээллийг устгахыг хүсэж байвал &apos;Тийм&apos;
                        товчийг дарна уу.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => setShowDeleteValidation(false)}
                    >
                        Болих
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                        autoFocus
                    >
                        Тийм
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
